/**
 * Renders an incident report component
 */

import React from 'react';
import { observer } from 'mobx-react';

// Translation
import translate from '../../translate/Translate';

const Report = observer(class Report extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      leave: false
    };

    // Bind this to functions
    this.handleCancel = this.handleCancel.bind(this);

    // Create refs
    this.type = React.createRef();
    this.notes = React.createRef();
  }

  handleCancel() {
    const { PlayerStore } = this.props.store;
    const { onCancel } = this.props;

    PlayerStore.session = null;

    this.setState({
      leave: true
    });

    setTimeout(() => {
      onCancel();
    }, 250);
  }

  render() {
    const { translation } = this.props;
    const { leave } = this.state;

    return (
      <div className="modal">
        <aside className={`modal__content${leave ? ' modal__content--exiting' : ''}`}>
          <header className="modal__head">
            <strong className="modal__title">
              {translation.heading}
            </strong>
          </header>

          <form className="form">
            <ul className="form__fields">
              <li>
                <label
                  className="form__lbl lbl-required"
                  htmlFor="report-type"
                >
                  {translation.type.label}
                </label>

                <label className="select">
                  <select
                    id="report-type"
                    onChange={null}
                    ref={this.type}
                    required
                    aria-required="true"
                    data-errormsg={translation.type.error_msg}
                  >
                    <option value="">{translation.type.helper}</option>

                    {Object.keys(translation.type.options).map((option, i) =>
                      <option
                        key={i}
                        value={option}
                      >
                        {translation.type.options[option]}
                      </option>
                    )}
                  </select>
                </label>
              </li>
              <li>
                <label
                  className="form__lbl lbl-required"
                  htmlFor="report-notes"
                >
                  {translation.notes.label}
                </label>

                <textarea
                  id="report-notes"
                  className="textarea--brief"
                  placeholder={translation.notes.helper}
                  onChange={null}
                  ref={this.notes}
                  required
                  aria-required="true"
                  data-errormsg={translation.notes.error_msg}
                ></textarea>
              </li>
            </ul>

            <div className="form__action">
              <button
                className="btn btn--outline"
                type="reset"
                onClick={this.handleCancel}
              >
                {translation.cancel}
              </button>

              <button
                className="btn"
                type="submit"
              >
                {translation.submit}
              </button>
            </div>
          </form>
        </aside>
      </div>
    );
  }
});

export default translate('Report')(Report);